/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RemoveClientFromMcpServerRequestBody,
  RemoveClientFromMcpServerRequestBody$Outbound,
  RemoveClientFromMcpServerRequestBody$outboundSchema,
} from "../components/removeclientfrommcpserverrequestbody.js";

export type RemoveOrganizationRemoteSessionClientFromMcpServerSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type RemoveOrganizationRemoteSessionClientFromMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  removeClientFromMcpServerRequestBody: RemoveClientFromMcpServerRequestBody;
};

/** @internal */
export type RemoveOrganizationRemoteSessionClientFromMcpServerSecurity$Outbound =
  {
    "session_header_Gram-Session"?: string | undefined;
    "apikey_header_Gram-Key"?: string | undefined;
  };

/** @internal */
export const RemoveOrganizationRemoteSessionClientFromMcpServerSecurity$outboundSchema:
  z.ZodMiniType<
    RemoveOrganizationRemoteSessionClientFromMcpServerSecurity$Outbound,
    RemoveOrganizationRemoteSessionClientFromMcpServerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function removeOrganizationRemoteSessionClientFromMcpServerSecurityToJSON(
  removeOrganizationRemoteSessionClientFromMcpServerSecurity:
    RemoveOrganizationRemoteSessionClientFromMcpServerSecurity,
): string {
  return JSON.stringify(
    RemoveOrganizationRemoteSessionClientFromMcpServerSecurity$outboundSchema
      .parse(removeOrganizationRemoteSessionClientFromMcpServerSecurity),
  );
}

/** @internal */
export type RemoveOrganizationRemoteSessionClientFromMcpServerRequest$Outbound =
  {
    "Gram-Session"?: string | undefined;
    "Gram-Key"?: string | undefined;
    RemoveClientFromMcpServerRequestBody:
      RemoveClientFromMcpServerRequestBody$Outbound;
  };

/** @internal */
export const RemoveOrganizationRemoteSessionClientFromMcpServerRequest$outboundSchema:
  z.ZodMiniType<
    RemoveOrganizationRemoteSessionClientFromMcpServerRequest$Outbound,
    RemoveOrganizationRemoteSessionClientFromMcpServerRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      removeClientFromMcpServerRequestBody:
        RemoveClientFromMcpServerRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        removeClientFromMcpServerRequestBody:
          "RemoveClientFromMcpServerRequestBody",
      });
    }),
  );

export function removeOrganizationRemoteSessionClientFromMcpServerRequestToJSON(
  removeOrganizationRemoteSessionClientFromMcpServerRequest:
    RemoveOrganizationRemoteSessionClientFromMcpServerRequest,
): string {
  return JSON.stringify(
    RemoveOrganizationRemoteSessionClientFromMcpServerRequest$outboundSchema
      .parse(removeOrganizationRemoteSessionClientFromMcpServerRequest),
  );
}
